import styled from 'styled-components';

const HotdesksView = styled.article`
  width: 100%;
  .room {
    position: relative;
    width: 100%;
    min-height: 600px;
    border: 4px solid ${props => props.theme.colors.primary};
    border-left: 4px dashed ${props => props.theme.colors.primary};
    background-color: #c9e6ff;

    @media (min-width: ${props => props.theme.breakpoints.sm}) {
      min-height: 250px;
      border: 4px solid ${props => props.theme.colors.primary};
      border-bottom: 4px dashed ${props => props.theme.colors.primary};
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: -4px;
      width: 15%;
      height: 21%;
      background-color: ${props => props.theme.colors.white};
      border: 4px solid ${props => props.theme.colors.primary};
      border-bottom: none;
      border-left: none;

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        width: 21%;
        height: 60px;
        top: auto;
        bottom: -4px;
        left: auto;
        right: -4px;
        border: 4px solid ${props => props.theme.colors.primary};
        border-bottom: none;
        border-right: none;
      }
    }

    // mac30 filtered styles for hotdesks

    &.filtered-mac {
      .desk:nth-child(even) {
        &:before {
          transform: rotate(0deg);

          @media (min-width: ${props => props.theme.breakpoints.sm}) {
            transform: rotate(-90deg);
          }
        }
      }
    }
  }

  .desk {
    --desk-height: 5.3%;
    --desk-width: 23%;
    --gutter: 1em;
    --desk-width-lg: 6.05%;
    --desk-height-lg: 32%;

    position: absolute;
    /* outline:1px solid black; */
    width: var(--desk-width);
    height: var(--desk-height);

    @media (min-width: ${props => props.theme.breakpoints.sm}) {
      width: var(--desk-width-lg);
      height: var(--desk-height-lg);
    }

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('data:image/svg+xml;utf8,<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511 511" style="enable-background:new 0 0 511 511;" xml:space="preserve"><g><rect y="200" x="10" width="96%" height="46%" fill="%23F9F9F9" /><rect y="130" x="180" width="29%" height="14%" fill="%23F9F9F9" /><rect y="75" x="180" width="28%" height="5%" fill="%23fff" /><path d="M487.5,192H335v-48.5c0-12.958-10.542-23.5-23.5-23.5H263v-9h48.5c10.336,0,19.128-6.71,22.266-16h1.734c4.687,0,8.5,3.813,8.5,8.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-12.958-10.542-23.5-23.5-23.5h-1.734c-3.138-9.29-11.93-16-22.266-16h-112c-10.336,0-19.128,6.71-22.266,16H175.5c-12.958,0-23.5,10.542-23.5,23.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-4.687,3.813-8.5,8.5-8.5h1.734c3.138,9.29,11.93,16,22.266,16H248v9h-48.5c-12.958,0-23.5,10.542-23.5,23.5V192H23.5C10.542,192,0,202.542,0,215.5v208C0,436.458,10.542,447,23.5,447h464c12.958,0,23.5-10.542,23.5-23.5v-208C511,202.542,500.458,192,487.5,192z M191,87.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5h-112C194.813,96,191,92.187,191,87.5z M191,143.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5V192H191V143.5z M496,423.5c0,4.687-3.813,8.5-8.5,8.5h-464c-4.687,0-8.5-3.813-8.5-8.5v-208c0-4.687,3.813-8.5,8.5-8.5h464c4.687,0,8.5,3.813,8.5,8.5V423.5z"/><path d="M342.776,333.681c-0.834-3.339-3.834-5.681-7.276-5.681H287v-16.5c0-4.142-3.358-7.5-7.5-7.5h-48c-4.142,0-7.5,3.358-7.5,7.5V328h-48.5c-3.441,0-6.441,2.342-7.276,5.681l-16,64c-0.561,2.24-0.057,4.614,1.364,6.435S157.19,407,159.5,407h192c2.31,0,4.49-1.064,5.912-2.884s1.925-4.194,1.364-6.435L342.776,333.681z M239,319h33v9h-33V319z M169.106,392l12.25-49h148.288l12.25,49H169.106z"/><path d="M183.5,271h128c4.142,0,7.5-3.358,7.5-7.5v-32c0-4.142-3.358-7.5-7.5-7.5h-128c-4.142,0-7.5,3.358-7.5,7.5v32C176,267.642,179.358,271,183.5,271z M191,239h113v17H191V239z"/><path d="M343.5,263c4.142,0,7.5-3.358,7.5-7.5v-16c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v16C336,259.642,339.358,263,343.5,263z"/></g></svg>')
        center no-repeat;
      pointer-events: none;
      transition: background-color 0.2s;
    }

    &:nth-child(even) {
      &:before {
        transform: rotate(180deg);

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          transform: rotate(90deg);
        }
      }
    }

    &:nth-child(odd) {
      &:before {
        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          transform: rotate(-90deg);
        }
      }
    }

    &:nth-child(4n + 1) {
      .desk-label {
        top: -5px;
        right: 14%;

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          top: 8px;
          right: auto;
          left: 0;
        }

        @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
          top: 2px;
          left: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.lgUp}) {
          top: 4px;
          left: 14%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xlUp}) {
          top: 2px;
          left: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
          top: -5px;
          left: 22%;
        }
      }
    }

    &:nth-child(4n + 2) {
      .desk-label {
        bottom: -5px;
        right: 14%;

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          bottom: auto;
          top: 8px;
          right: 0;
        }

        @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
          top: 2px;
          right: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.lgUp}) {
          top: 4px;
          right: 14%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xlUp}) {
          top: 2px;
          right: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
          top: -5px;
          right: 22%;
        }
      }
    }

    &:nth-child(4n + 3) {
      .desk-label {
        top: -5px;
        left: 14%;

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          top: auto;
          bottom: 8px;
          left: 0;
        }

        @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
          bottom: 2px;
          left: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.lgUp}) {
          bottom: 4px;
          left: 14%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xlUp}) {
          bottom: 2px;
          left: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
          bottom: -5px;
          left: 22%;
        }
      }
    }

    &:nth-child(4n) {
      .desk-label {
        bottom: -5px;
        left: 14%;

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          left: auto;
          bottom: 8px;
          right: 0;
        }

        @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
          bottom: 2px;
          right: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.lgUp}) {
          bottom: 4px;
          right: 14%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xlUp}) {
          bottom: 2px;
          right: 18%;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
          bottom: -5px;
          right: 22%;
        }
      }
    }

    .desk-content {
      display: block;
      width: 100%;
      height: 100%;
    }

    .desk-label {
      position: absolute;
      width: 22px;
      height: 22px;
      font-size: 12px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid ${props => props.theme.colors.black};
      border-radius: 50%;
      background-color: white;
      line-height: 1;
      pointer-events: none;

      @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
        width: 24px;
        height: 24px;
        border-width: 2px;
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.mdUp}) {
      &:hover {
        .tooltip {
          visibility: visible;
          opacity: 1;
        }

        &:before {
          background: url('data:image/svg+xml;utf8,<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511 511" style="enable-background:new 0 0 511 511;" xml:space="preserve"><g><rect y="200" x="10" width="96%" height="46%" fill="%23d9d9d9" /><rect y="130" x="180" width="29%" height="14%" fill="%23F9F9F9" /><rect y="75" x="180" width="28%" height="5%" fill="%23fff" /><path d="M487.5,192H335v-48.5c0-12.958-10.542-23.5-23.5-23.5H263v-9h48.5c10.336,0,19.128-6.71,22.266-16h1.734c4.687,0,8.5,3.813,8.5,8.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-12.958-10.542-23.5-23.5-23.5h-1.734c-3.138-9.29-11.93-16-22.266-16h-112c-10.336,0-19.128,6.71-22.266,16H175.5c-12.958,0-23.5,10.542-23.5,23.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-4.687,3.813-8.5,8.5-8.5h1.734c3.138,9.29,11.93,16,22.266,16H248v9h-48.5c-12.958,0-23.5,10.542-23.5,23.5V192H23.5C10.542,192,0,202.542,0,215.5v208C0,436.458,10.542,447,23.5,447h464c12.958,0,23.5-10.542,23.5-23.5v-208C511,202.542,500.458,192,487.5,192z M191,87.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5h-112C194.813,96,191,92.187,191,87.5z M191,143.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5V192H191V143.5z M496,423.5c0,4.687-3.813,8.5-8.5,8.5h-464c-4.687,0-8.5-3.813-8.5-8.5v-208c0-4.687,3.813-8.5,8.5-8.5h464c4.687,0,8.5,3.813,8.5,8.5V423.5z"/><path d="M342.776,333.681c-0.834-3.339-3.834-5.681-7.276-5.681H287v-16.5c0-4.142-3.358-7.5-7.5-7.5h-48c-4.142,0-7.5,3.358-7.5,7.5V328h-48.5c-3.441,0-6.441,2.342-7.276,5.681l-16,64c-0.561,2.24-0.057,4.614,1.364,6.435S157.19,407,159.5,407h192c2.31,0,4.49-1.064,5.912-2.884s1.925-4.194,1.364-6.435L342.776,333.681z M239,319h33v9h-33V319z M169.106,392l12.25-49h148.288l12.25,49H169.106z"/><path d="M183.5,271h128c4.142,0,7.5-3.358,7.5-7.5v-32c0-4.142-3.358-7.5-7.5-7.5h-128c-4.142,0-7.5,3.358-7.5,7.5v32C176,267.642,179.358,271,183.5,271z M191,239h113v17H191V239z"/><path d="M343.5,263c4.142,0,7.5-3.358,7.5-7.5v-16c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v16C336,259.642,339.358,263,343.5,263z"/></g></svg>')
            center no-repeat;
        }
      }
    }

    // desk positions

    --top: 6%;
    --right: 10%;
    --left-column: calc(var(--right) + var(--desk-width));
    --left: 2%;
    --right-column: calc(var(--left) + var(--desk-width));
    --top-lg: calc(var(--top) + var(--desk-height-lg));

    &.desk-1,
    &.desk-2,
    &.desk-3,
    &.desk-4,
    &.desk-5,
    &.desk-6,
    &.desk-7,
    &.desk-8,
    &.desk-9,
    &.desk-10,
    &.desk-11,
    &.desk-12,
    &.desk-13,
    &.desk-14,
    &.desk-15,
    &.desk-16,
    &.desk-17,
    &.desk-18,
    &.desk-19,
    &.desk-20,
    &.desk-21,
    &.desk-22,
    &.desk-23,
    &.desk-24,
    &.desk-25,
    &.desk-26,
    &.desk-27,
    &.desk-28 {
      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        right: auto;
      }
    }

    //group

    &.desk-1 {
      top: var(--top);
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        left: var(--left);
      }
    }

    &.desk-2 {
      top: calc(var(--top) + var(--desk-height));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        right: auto;
        left: calc(var(--left) + var(--desk-width-lg));
      }
    }

    &.desk-3 {
      top: var(--top);
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        right: auto;
        left: var(--left);
      }
    }

    &.desk-4 {
      top: calc(var(--top) + var(--desk-height));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        right: auto;
        left: calc(var(--left) + var(--desk-width-lg));
      }
    }

    //group

    &.desk-5 {
      top: calc(var(--top) + 2 * var(--desk-height) + var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 2 * var(--desk-width-lg) + var(--gutter));
      }
    }

    &.desk-6 {
      top: calc(var(--top) + 3 * var(--desk-height) + var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 3 * var(--desk-width-lg) + var(--gutter));
      }
    }

    &.desk-7 {
      top: calc(var(--top) + 2 * var(--desk-height) + var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 2 * var(--desk-width-lg) + var(--gutter));
      }
    }

    &.desk-8 {
      top: calc(var(--top) + 3 * var(--desk-height) + var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 3 * var(--desk-width-lg) + var(--gutter));
      }
    }

    //group

    &.desk-9 {
      top: calc(var(--top) + 4 * var(--desk-height) + 2 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 4 * var(--desk-width-lg) + 2 * var(--gutter));
      }
    }

    &.desk-10 {
      top: calc(var(--top) + 5 * var(--desk-height) + 2 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 5 * var(--desk-width-lg) + 2 * var(--gutter));
      }
    }

    &.desk-11 {
      top: calc(var(--top) + 4 * var(--desk-height) + 2 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 4 * var(--desk-width-lg) + 2 * var(--gutter));
      }
    }

    &.desk-12 {
      top: calc(var(--top) + 5 * var(--desk-height) + 2 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 5 * var(--desk-width-lg) + 2 * var(--gutter));
      }
    }

    //group

    &.desk-13 {
      top: calc(var(--top) + 6 * var(--desk-height) + 3 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 6 * var(--desk-width-lg) + 3 * var(--gutter));
      }
    }

    &.desk-14 {
      top: calc(var(--top) + 7 * var(--desk-height) + 3 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 7 * var(--desk-width-lg) + 3 * var(--gutter));
      }
    }

    &.desk-15 {
      top: calc(var(--top) + 6 * var(--desk-height) + 3 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 6 * var(--desk-width-lg) + 3 * var(--gutter));
      }
    }

    &.desk-16 {
      top: calc(var(--top) + 7 * var(--desk-height) + 3 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 7 * var(--desk-width-lg) + 3 * var(--gutter));
      }
    }

    //group

    &.desk-17 {
      top: calc(var(--top) + 8 * var(--desk-height) + 4 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 8 * var(--desk-width-lg) + 4 * var(--gutter));
      }
    }

    &.desk-18 {
      top: calc(var(--top) + 9 * var(--desk-height) + 4 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 9 * var(--desk-width-lg) + 4 * var(--gutter));
      }
    }

    &.desk-19 {
      top: calc(var(--top) + 8 * var(--desk-height) + 4 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 8 * var(--desk-width-lg) + 4 * var(--gutter));
      }
    }

    &.desk-20 {
      top: calc(var(--top) + 9 * var(--desk-height) + 4 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 9 * var(--desk-width-lg) + 4 * var(--gutter));
      }
    }

    //group

    &.desk-21 {
      top: calc(var(--top) + 10 * var(--desk-height) + 5 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 10 * var(--desk-width-lg) + 5 * var(--gutter));
      }
    }

    &.desk-22 {
      top: calc(var(--top) + 11 * var(--desk-height) + 5 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 11 * var(--desk-width-lg) + 5 * var(--gutter));
      }
    }

    &.desk-23 {
      top: calc(var(--top) + 10 * var(--desk-height) + 5 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 10 * var(--desk-width-lg) + 5 * var(--gutter));
      }
    }

    &.desk-24 {
      top: calc(var(--top) + 11 * var(--desk-height) + 5 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 11 * var(--desk-width-lg) + 5 * var(--gutter));
      }
    }

    //group

    &.desk-25 {
      top: calc(var(--top) + 12 * var(--desk-height) + 6 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 12 * var(--desk-width-lg) + 6 * var(--gutter));
      }
    }

    &.desk-26 {
      top: calc(var(--top) + 13 * var(--desk-height) + 6 * var(--gutter));
      right: var(--right);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top);
        left: calc(var(--left) + 13 * var(--desk-width-lg) + 6 * var(--gutter));
      }
    }

    &.desk-27 {
      top: calc(var(--top) + 12 * var(--desk-height) + 6 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 12 * var(--desk-width-lg) + 6 * var(--gutter));
      }
    }

    &.desk-28 {
      top: calc(var(--top) + 13 * var(--desk-height) + 6 * var(--gutter));
      right: var(--left-column);

      @media (min-width: ${props => props.theme.breakpoints.sm}) {
        top: var(--top-lg);
        left: calc(var(--left) + 13 * var(--desk-width-lg) + 6 * var(--gutter));
      }
    }

    &.disabled {
      cursor: not-allowed;

      &:before {
        background: url('data:image/svg+xml;utf8,<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511 511" style="enable-background:new 0 0 511 511;" xml:space="preserve"><g><rect y="200" x="10" width="96%" height="46%" fill="%23d9d9d9" /><rect y="130" x="180" width="29%" height="14%" fill="%23d9d9d9" /><rect y="75" x="180" width="28%" height="5%" fill="%23d9d9d9" /><path fill="%23a2a2a2" d="M487.5,192H335v-48.5c0-12.958-10.542-23.5-23.5-23.5H263v-9h48.5c10.336,0,19.128-6.71,22.266-16h1.734c4.687,0,8.5,3.813,8.5,8.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-12.958-10.542-23.5-23.5-23.5h-1.734c-3.138-9.29-11.93-16-22.266-16h-112c-10.336,0-19.128,6.71-22.266,16H175.5c-12.958,0-23.5,10.542-23.5,23.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72c0-4.687,3.813-8.5,8.5-8.5h1.734c3.138,9.29,11.93,16,22.266,16H248v9h-48.5c-12.958,0-23.5,10.542-23.5,23.5V192H23.5C10.542,192,0,202.542,0,215.5v208C0,436.458,10.542,447,23.5,447h464c12.958,0,23.5-10.542,23.5-23.5v-208C511,202.542,500.458,192,487.5,192z M191,87.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5h-112C194.813,96,191,92.187,191,87.5z M191,143.5c0-4.687,3.813-8.5,8.5-8.5h112c4.687,0,8.5,3.813,8.5,8.5V192H191V143.5z M496,423.5c0,4.687-3.813,8.5-8.5,8.5h-464c-4.687,0-8.5-3.813-8.5-8.5v-208c0-4.687,3.813-8.5,8.5-8.5h464c4.687,0,8.5,3.813,8.5,8.5V423.5z"/><path fill="%23a2a2a2" d="M342.776,333.681c-0.834-3.339-3.834-5.681-7.276-5.681H287v-16.5c0-4.142-3.358-7.5-7.5-7.5h-48c-4.142,0-7.5,3.358-7.5,7.5V328h-48.5c-3.441,0-6.441,2.342-7.276,5.681l-16,64c-0.561,2.24-0.057,4.614,1.364,6.435S157.19,407,159.5,407h192c2.31,0,4.49-1.064,5.912-2.884s1.925-4.194,1.364-6.435L342.776,333.681z M239,319h33v9h-33V319z M169.106,392l12.25-49h148.288l12.25,49H169.106z"/><path fill="%23a2a2a2" d="M183.5,271h128c4.142,0,7.5-3.358,7.5-7.5v-32c0-4.142-3.358-7.5-7.5-7.5h-128c-4.142,0-7.5,3.358-7.5,7.5v32C176,267.642,179.358,271,183.5,271z M191,239h113v17H191V239z"/><path fill="%23a2a2a2" d="M343.5,263c4.142,0,7.5-3.358,7.5-7.5v-16c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v16C336,259.642,339.358,263,343.5,263z"/></g></svg>')
          center no-repeat;
      }
    }

    &.mac {
      &:after {
        content: '';
        position: absolute;
        top: 17px;
        right: calc(50% - 11px);
        width: 16px;
        height: 16px;
        border: 1px solid ${props => props.theme.colors.black};
        border-radius: 50%;
        pointer-events: none;
        background: ${props => props.theme.colors.white}
          url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="iso-8859-1"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="512" height="512"><g><path d="M185.255,512c-76.201-0.439-139.233-155.991-139.233-235.21c0-129.404,97.075-157.734,134.487-157.734 c16.86,0,34.863,6.621,50.742,12.48c11.104,4.087,22.588,8.306,28.975,8.306c3.823,0,12.832-3.589,20.786-6.738 c16.963-6.753,38.071-15.146,62.651-15.146c0.044,0,0.103,0,0.146,0c18.354,0,74.004,4.028,107.461,54.272l7.837,11.777 l-11.279,8.511c-16.113,12.158-45.513,34.336-45.513,78.267c0,52.031,33.296,72.041,49.292,81.665 c7.061,4.248,14.37,8.628,14.37,18.208c0,6.255-49.922,140.566-122.417,140.566c-17.739,0-30.278-5.332-41.338-10.034 c-11.191-4.761-20.845-8.862-36.797-8.862c-8.086,0-18.311,3.823-29.136,7.881C221.496,505.73,204.752,512,185.753,512H185.255z"/><path d="M351.343,0c1.888,68.076-46.797,115.304-95.425,112.342C247.905,58.015,304.54,0,351.343,0z"/></g></svg>')
          50%/10px no-repeat;

        @media (min-width: ${props => props.theme.breakpoints.sm}) {
          background-size: 14px;
          top: calc(50% - 11px);
          right: 2px;
          width: 22px;
          height: 22px;
        }

        @media (min-width: ${props => props.theme.breakpoints.xlUp}) {
          right: 0;
        }

        @media (min-width: ${props => props.theme.breakpoints.xxlUp}) {
          top: calc(50% - 12px);
          right: 2px;
          width: 24px;
          height: 24px;
          border-width: 2px;
        }
      }
    }
  }
`;

export { HotdesksView };
